import { useEffect, useState } from 'react';
import ConfirmationModal from '../../../components/commoncomponents/ConfirmationModal';
import ProfileModal from '../../superadmin/components/ProfileModal';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';

function AdminLayout({
  user,
  token,
  selectedBusiness,
  onLogout,
  onProfileUpdate,
  onPasswordChanged,
  activeView,
  onSelectView,
  children,
}) {
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const animationFrame = window.requestAnimationFrame(() => {
      setIsVisible(true);
    });

    return () => {
      window.cancelAnimationFrame(animationFrame);
    };
  }, []);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(false);
      }
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function openLogoutModal() {
    setIsLogoutModalOpen(true);
  }

  function closeLogoutModal() {
    setIsLogoutModalOpen(false);
  }

  function confirmLogout() {
    closeLogoutModal();
    onLogout();
  }

  return (
    <div
      className={`min-h-screen bg-[linear-gradient(180deg,#fcfbf9_0%,#f7f2ec_100%)] text-[#111111] transition-all duration-500 ease-out lg:grid lg:grid-cols-[320px_minmax(0,1fr)] ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-3 opacity-0'
      }`}
    >
      <AdminSidebar
        activeView={activeView}
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        onSelectView={onSelectView}
        selectedBusiness={selectedBusiness}
      />

      <main className="relative flex min-h-screen min-w-0 flex-col p-2.5 sm:p-6 lg:p-[24px_30px_30px]">
        <AdminHeader
          isSidebarOpen={isSidebarOpen}
          user={user}
          onToggleSidebar={() => setIsSidebarOpen((currentValue) => !currentValue)}
          selectedBusiness={selectedBusiness}
          onLogout={openLogoutModal}
          onOpenProfile={() => setIsProfileModalOpen(true)}
        />
        <section className="mt-4 flex min-h-0 flex-1 flex-col sm:mt-6">{children}</section>
      </main>

      <ConfirmationModal
        isOpen={isLogoutModalOpen}
        title="Confirm Logout"
        description="Are you sure you want to log out of the current session?"
        confirmLabel="Logout"
        onConfirm={confirmLogout}
        onCancel={closeLogoutModal}
      />

      <ProfileModal
        isOpen={isProfileModalOpen}
        user={user}
        token={token}
        onClose={() => setIsProfileModalOpen(false)}
        onSaveProfile={onProfileUpdate}
        onPasswordChanged={onPasswordChanged}
      />
    </div>
  );
}

export default AdminLayout;
